
export const HomePage = () => {
  return (
    <div>
      Welcome to Kinky Spice!
    </div>
  )
}